import React from 'react';
import { motion } from 'framer-motion';
const AMENITIES = ['Piscina Principal Circular', 'Sauna de Madera', 'Gym al Aire Libre', 'Restaurante y Bar', 'Mallas Catamarán', 'Coctelería Premium', 'Fogatas Nocturnas', 'Ping Pong', 'Badminton', 'Bicicletas', 'Parqueadero Gratuito', 'WiFi Completo'];
const MOSAIC = [{
  img: 'https://i.imgur.com/ZAWFdZ5.jpeg',
  label: 'Sauna'
}, {
  img: 'https://i.imgur.com/FGOiEw1.jpeg',
  label: 'Mallas Catamarán'
}, {
  img: 'https://i.imgur.com/wl1agAp.jpeg',
  label: 'Gym'
}, {
  img: 'https://i.imgur.com/za4I4Si.jpeg',
  label: 'Entrada'
}];
export function FacilitiesSection() {
  return <section id="instalaciones" className="bg-night px-6 sm:px-8 lg:px-12 py-20 md:py-28" data-id="element-145" data-mp="2cf13alus0qy7">
      <div className="max-w-[1400px] mx-auto" data-id="element-146" data-mp="27h9dpyhltgx6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center mb-16" data-id="element-147" data-mp="111fgv8gax3gd">
          <motion.div initial={{
          opacity: 0,
          y: 35
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.8
        }} data-id="element-148" data-mp="w2vr0wyl77iq">
            <span className="inline-block text-[0.67rem] font-semibold tracking-[0.3em] uppercase text-gold mb-5" data-id="element-149" data-mp="1fhnfp3if4x4m">
              Instalaciones
            </span>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.15] text-white mb-5" data-id="element-150" data-mp="16gpc2mbw6rmk">
              Un recinto<br data-id="element-151" data-mp="rrjfl64fvfid" />
              <em className="italic text-gold" data-id="element-152" data-mp="rqzw3kz54j28">completo para ti</em>
            </h2>
            <p className="text-[0.88rem] text-white/50 leading-[1.8] mb-8" data-id="element-153" data-mp="wirn1wm7kqsw">
              No solo una cabaña. Un destino completo con todo lo que necesitas para desconectarte de verdad.
            </p>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2.5 list-none" data-id="element-154" data-mp="npelk6a2wgv7">
              {AMENITIES.map(item => <li key={item} className="flex items-center gap-2.5 text-[0.83rem] text-white/65" data-id="element-155" data-mp="8tp9azup3i3o">
                  <span className="w-[5px] h-[5px] rounded-full bg-gold shrink-0" data-id="element-156" data-mp="dr8lzvbqvmti" />
                  {item}
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 35
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative rounded-[40px] overflow-hidden h-[460px] group" data-id="element-157" data-mp="3m1azuw9jsdgo">
            <img src="https://i.imgur.com/PaXFJV1.png" alt="Piscina principal noche hamacas" className="w-full h-full object-cover transition-transform duration-[800ms] group-hover:scale-[1.04]" data-id="element-158" data-mp="dlhqd1dmw294" />
          </motion.div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-159" data-mp="3uumwtfatmtvh">
          {MOSAIC.map((item, i) => <motion.div key={item.label} initial={{
          opacity: 0,
          y: 35
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.8,
          delay: (i + 1) * 0.1
        }} className="group relative rounded-2xl overflow-hidden aspect-square cursor-pointer transition-transform duration-[350ms] hover:scale-[1.03] hover:z-10" data-id="element-160" data-mp="2oe2jffoelulj" data-mpi={i}>
              <img src={item.img} alt={item.label} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-161" data-mp="18u1unvgt714e" />
              <div className="absolute inset-0 bg-transparent flex items-end p-4 transition-colors duration-500 group-hover:bg-black/40" data-id="element-162" data-mp="1ilxsr6iwar8m">
                <span className="text-[0.73rem] font-medium tracking-[0.08em] uppercase text-white opacity-0 translate-y-1.5 transition-all duration-300 group-hover:opacity-100 group-hover:translate-y-0" data-id="element-163" data-mp="1mkybyq5abvw5">
                  {item.label}
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 35
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.8
      }} className="bg-gradient-to-br from-forest-900 to-[#243824] rounded-[40px] p-8 sm:p-10 lg:p-14 flex flex-col md:flex-row items-center gap-6 md:gap-10 mt-12 relative overflow-hidden text-center md:text-left" data-id="element-164" data-mp="26wn86lsz7b1">
          <div className="absolute -top-20 -right-20 w-[300px] h-[300px] rounded-full bg-white/[0.02]" data-id="element-165" data-mp="1xmv0bw62jonx" />
          <div className="w-[68px] h-[68px] shrink-0 bg-white/[0.08] rounded-full flex items-center justify-center" data-id="element-166" data-mp="19yli1482dj1j">
            <svg viewBox="0 0 24 24" className="w-[34px] h-[34px] fill-gold" data-id="element-167" data-mp="14zqrth7ros7e">
              <path d="M4.5 9.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm15 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm-7.5-5a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM7 13.5c-1.1 0-2 .9-2 2v1c0 2.8 2.7 5.5 7 5.5s7-2.7 7-5.5v-1c0-1.1-.9-2-2-2h-2.5c-.3 0-.5.2-.5.5s-.2.5-.5.5h-3c-.3 0-.5-.2-.5-.5s-.2-.5-.5-.5H7z" data-id="element-168" data-mp="1iq405kokm8x9" />
            </svg>
          </div>
          <div className="relative z-10" data-id="element-169" data-mp="m6wh4zh6fm8z">
            <h3 className="font-display text-[1.75rem] font-light text-white mb-2" data-id="element-170" data-mp="m64yep8ohj04">Pet Friendly 🐾</h3>
            <p className="text-[0.88rem] text-white/60 leading-[1.7] max-w-[560px]" data-id="element-171" data-mp="c26cglue2412">
              Tu mejor amigo también merece descansar. En Refugio Caracolí los animales son bienvenidos. Espacios amplios, naturaleza pura y ambiente seguro.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}